import React from "react"
import Image from "./Image"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default function Hero(props) {
  const data = props.data
  const socialMedia = data.socialMedia
  const callToAction = data.callToAction

  return (
    <div className="hero-container">
      {data.logoImage && (
        <Link to="/">
          <Image className="logo" alt="logo" src={data.logoImage} optimized />
        </Link>
      )}

      <h1
        className="title"
        dangerouslySetInnerHTML={{ __html: data.title }}
      ></h1>
      {data.subtitle && <p className="subtitle">{data.subtitle}</p>}

      {socialMedia && (
        <ul className="social-media">
          {socialMedia.map(item => {
            if (item.icon && String(item.icon.name) !== "") {
              return (
                <li key={item.icon.name}>
                  <a href={item.href} target="_blank" rel="noopener noreferrer">
                    {String(item.icon.group) !== "" ? (
                      <FontAwesomeIcon
                        icon={[item.icon.group, item.icon.name]}
                      />
                    ) : (
                      <FontAwesomeIcon icon={item.icon.name} />
                    )}
                  </a>
                </li>
              )
            } else {
              return null
            }
          })}
        </ul>
      )}

      <div className="cta-bar">
        {callToAction &&
          callToAction.map(cta => {
            if (cta.target === "_self") {
              return (
                <Link
                  key={cta.id}
                  id={cta.id}
                  to={cta.href}
                  className={`cta ${cta.className}`}
                >
                  <span id={cta.id} className="gradient"></span>
                  {cta.text}
                </Link>
              )
            } else {
              return (
                <a
                  id={cta.id}
                  target={cta.target || "_blank"}
                  href={cta.href}
                  className={`cta ${cta.className}`}
                  rel="noopener noreferrer"
                >
                  <span id={cta.id} className="gradient"></span>
                  {cta.text}
                </a>
              )
            }
          })}
      </div>
    </div>
  )
}
